// extracted by mini-css-extract-plugin
export default {"main":"_54069a9888 f438ab492c _292cd8980d _307a62f0b4","title":"_4f7880bbd7"};